import { render, staticRenderFns } from "./MiniCart.vue?vue&type=template&id=5c7d6589&"
import script from "./MiniCart.ts?vue&type=script&lang=ts&"
export * from "./MiniCart.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports